import React, { useMemo } from 'react';

import { Flex } from 'antd';
import { DatabaseOutlined } from '@ant-design/icons';
import { WidgetStatistic } from 'src/pages/dashboard/styles';
import { FaCaretDown, FaCaretRight, FaCaretUp } from 'react-icons/fa';
import useOccurrences from 'src/pages/dashboard/contexts/useOccurrences';
import {
	CardData,
	CardTitle,
	IconArea
} from 'src/pages/dashboard/components/cards/styles';

export default function TotalOccurrences() {
	const { occurrences, lastPeriodOccurrences, } = useOccurrences();

	const data = useMemo(() => {
		return occurrences.filter(occ => !occ.is_recovery).length;
	}, [ occurrences, ]);

	const statistic = useMemo(() => {
		const currentTotal = occurrences.filter(occ => !occ.is_recovery).length;

		const lastPeriodTotal = lastPeriodOccurrences
			.filter(occ => !occ.is_recovery)
			.length;

		if (lastPeriodTotal === 0) return 100;

		return ((currentTotal - lastPeriodTotal) / lastPeriodTotal) * 100;
	}, [ lastPeriodOccurrences.length, occurrences.length, ]);

	return (
		<Flex
			gap={16}
			justify='space-between'
			style={{ width: '100%', }}
		>
			<Flex vertical gap={4}>
				<CardTitle>
					Total de ocorrências:
				</CardTitle>
				<CardData>
					<span>{data}</span>
					<WidgetStatistic
						style={{
							color: statistic > 0
								? '#FF0000' : statistic < 0
									? '#52C41A' : 'inherit',
							borderColor: statistic > 0
								? '#FF0000' : statistic < 0
									? '#52C41A' : 'inherit',
						}}
					>
						{
							statistic > 0
								? <FaCaretUp /> : statistic < 0
									? <FaCaretDown /> : <FaCaretRight />
						}
						{Math.abs(statistic)?.toFixed(2)}
					</WidgetStatistic>
				</CardData>
			</Flex>
			<IconArea>
				<DatabaseOutlined style={{ fontSize: 24, color: '#fff', }} />
			</IconArea>
		</Flex>
	);
}
